import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/orderPaySuccess.vue'
createPage(Page)